export enum VisibilityLevel {
  UPTIME_USERS = 'UPTIME_USERS',
  PUBLIC = 'PUBLIC',
  EXTERNAL_USERS = 'EXTERNAL_USERS',
}
